const hostname = process.env.REACT_APP_HOSTNAME;
if (!hostname) {
  throw "Hostname is not set in env file";
}

const url = {
  ping: `${hostname}/ping`,

  // User routes
  isAuthenticated: `${hostname}/me`,
  login: `${hostname}/login`,
  logout: `${hostname}/logout`,

  // Admin routes
  users: `${hostname}/users`,
  user: `${hostname}/users/:userId`,

  // Recipient routes
  recipients: `${hostname}/recipients`,
  recipient: `${hostname}/recipients/:recipientId`,
  recipientDonations: `${hostname}/recipients/:recipientId/donations`,

  // Recipient item routes
  recipientProgresses: `${hostname}/recipients/:recipientId/progress`,
  recipientProgress: `${hostname}/recipients/:recipientId/progress/:progressId`,
  recipientThankYouNotes: `${hostname}/recipients/:recipientId/thank-you-notes`,
  recipientProgressThankYouNotes: `${hostname}/recipients/:recipientId/progress/:progressId/thank-you-notes`,
  recipientProgressThankYouNote: `${hostname}/recipients/:recipientId/progress/:progressId/thank-you-notes/:thankYouNoteId`,
  recipientReceipts: `${hostname}/recipients/:recipientId/receipts`,
  recipientProgressReceipts: `${hostname}/recipients/:recipientId/progress/:progressId/receipts`,
  recipientProgressReceipt: `${hostname}/recipients/:recipientId/progress/:progressId/receipts/:receiptId`,
  recipientPhotos: `${hostname}/recipients/:recipientId/photos`,
  recipientProgressPhotos: `${hostname}/recipients/:recipientId/progress/:progressId/photos`,
  recipientProgressPhoto: `${hostname}/recipients/:recipientId/progress/:progressId/photos/:photoId`,
  recipientApps: `${hostname}/recipients/:recipientId/apps`,
  recipientProgressApps: `${hostname}/recipients/:recipientId/progress/:progressId/apps`,
  recipientProgressApp: `${hostname}/recipients/:recipientId/progress/:progressId/apps/:appId`,
  recipientMiscDocs: `${hostname}/recipients/:recipientId/misc-docs`,
  recipientProgressMiscDocs: `${hostname}/recipients/:recipientId/progress/:progressId/misc-docs`,
  recipientProgressMiscDoc: `${hostname}/recipients/:recipientId/progress/:progressId/misc-docs/:docId`,
  recipientReportCards: `${hostname}/recipients/:recipientId/report-cards`,
  recipientProgressReportCards: `${hostname}/recipients/:recipientId/progress/:progressId/report-cards`,
  recipientProgressReportCard: `${hostname}/recipients/:recipientId/progress/:progressId/report-cards/:reportCardId`,

  // Reconcile
  reportingFilter: `${hostname}/reporting/recipients/.filter`,
  reportingDonors: `${hostname}/reporting/donors/.filter`,
  reconcile: `${hostname}/recipients/.reconcile`,

  // Donor routes
  donors: `${hostname}/donors`,
  donor: `${hostname}/donors/:donorId`,
  donations: `${hostname}/donors/:donorId/donations`,
  donation: `${hostname}/donors/:donorId/donations/:donationId`,
  donorRecipientsLinks: `${hostname}/donors/:donorId/recipients`,
  donorRecipientLinks: `${hostname}/donors/:donorId/recipients/:recipientId/donors-recipients-links`,
  donorRecipientLinkByID: `${hostname}/donors/:donorId/recipients/:recipientId/donors-recipients-links/:donorRecipientLinkId`,
  donorRecipientLinkProgresses: `${hostname}/donors/:donorId/recipients/:recipientId/donors-recipients-links/:donorRecipientLinkId/progresses`,
  donorEmailUpdate: `${hostname}/donors/:donorId/recipients/:recipientId/donors-recipients-links/:donorRecipientLinkId/emails/DonorUpdate`,

  // Helper routes
  recipientStatuses: `${hostname}/helpers/recipient-statuses`,
  supportedCurrencies: `${hostname}/helpers/supported-currencies`
};

export default url;



// WEBPACK FOOTER //
// ./src/helpers/url.js